<template>
    <div class="kpiContainer" :data-engagementHash="this.engagementHash">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "KPIBox",
        props: ['engagementHash']
    }
</script>

<style scoped>
    .kpiContainer {
        display: flex;
        flex-flow: column;
        padding: 1rem 0.7rem;
    }

    .kpiContainer > * {
        width: 100%;
    }
</style>